import type { NormalisedUser, ServerResponse } from '@onhandtech/onhand-fe-shared/lib/api/v4/user'
import { moduleName } from '@onhandtech/onhand-fe-shared/lib/api/v4/user'
import { handleSuccess } from '@onhandtech/onhand-fe-shared/lib/api/v4/user/services/handle-success'
import type { GetUserParameters } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/user/user'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError, formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'
import { getConfig } from 'config/configuration'

type ClientResponse = {
  items: NormalisedUser[]
}

const args: RequestArgs<ServerResponse, ClientResponse, GetUserParameters> = {
  method: 'GET',
  url: formatEndpoint(getConfig().endpoints.api.v4.user),
  handleSuccess,
  handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
}

const usersModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse, GetUserParameters>({ moduleName, args })

export default usersModule
